
import { createSsapInputId } from '../miscellaneous/createSsapInputId';

export const getValueFromSsapFormSnapshot = (snapshot, indexInArray, fields, name) => {
    const inputId = createSsapInputId(indexInArray, fields, name);

    const foundInput = snapshot.find(input => input.inputId === inputId);

    return foundInput ? foundInput.value : null;
};